import { render } from "./SimpleCardDialog.vue?vue&type=template&id=14e05495"
import script from "./SimpleCardDialog.vue?vue&type=script&lang=js"
export * from "./SimpleCardDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__